export const HAUTEUR = 'Hauteur';
export const BANDEAU = 'Bandeau';

export const FORMAT_PRESSE_SENS_TYPE = [
  { libelle: 'addEditTypeFormatPresse.sensType.hauteur', value: HAUTEUR },
  { libelle: 'addEditTypeFormatPresse.sensType.bandeau', value: BANDEAU },
];

export const CLOS = 'Clos';
export const OUVERT = 'Ouvert';

export const MOIS_COMPTABLE_TYPE = [
  { libelle: 'addEditMoisComptable.etatType.ouvert', value: OUVERT },
  { libelle: 'addEditMoisComptable.etatType.clos', value: CLOS },
];

export const EXPORT_EXCEL_VENTE_SUPPORT = 'ventessupport';
